import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/scan-cargoV2-badges/empty-state.svg'


const _hoisted_1 = { class: "w-full overflow-auto custom-scrollbar" }
const _hoisted_2 = {
  key: 0,
  class: "relative mt-4"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_4 = { class: "space-y-3" }
const _hoisted_5 = { class: "flex items-center gap-2 min-w-0" }
const _hoisted_6 = { class: "text-gray-800 font-semibold" }
const _hoisted_7 = {
  key: 0,
  class: "bg-red-100 text-red-600 text-[10px] px-1 py-0.5 rounded border border-red-200 font-bold inline-block ml-2"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" DG ")
const _hoisted_9 = {
  key: 1,
  class: "bg-yellow-100 text-yellow-600 text-[10px] px-1 py-0.5 rounded border border-yellow-200 font-bold inline-block"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" K ")
const _hoisted_11 = {
  key: 0,
  class: "text-gray-400 text-xs"
}
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_13 = { class: "text-gray-500 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.items.length)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_TableV2, {
            data: _ctx.form.bagOrStt,
            columns: _ctx.columns,
            borderTop: false,
            "is-hard-pagination": false,
            "is-quick-search": false,
            "is-sorting": false,
            "pagination-style": "v2",
            customButtonAction: _ctx.customButton,
            isShowPagination: false,
            isSpaceTop: false,
            isSpaceBottom: false,
            isPinnedScrollBottom: false,
            isNoPaddingBottom: true
          }, {
            "top-left-table": _withCtx(() => [
              _hoisted_3
            ]),
            stt_no: _withCtx(({item}) => [
              _createVNode("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.sttDetails, (detail) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "min-w-0",
                    key: detail.sttNo
                  }, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("span", _hoisted_6, _toDisplayString(detail.sttNo || "-"), 1),
                      (detail.isDangerousGoods)
                        ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_7, [
                            _hoisted_8
                          ], 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('cargoV2.components.common.dangerousGoods'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true),
                      (detail.isQuarantine)
                        ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_9, [
                            _hoisted_10
                          ], 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('cargoV2.components.common.quarantine'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    (
                  (detail.shipmentId && detail.shipmentId !== '-') ||
                    (detail.sttShipmentId && detail.sttShipmentId !== '-')
                )
                      ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(item.sttShipmentId || item.shipmentId), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["data", "columns", "customButtonAction"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_12, [
          _createVNode("img", {
            src: _imports_0,
            alt: _ctx.$t('cargoV2.components.scanTableList.emptyStateAlt'),
            class: "w-40 mb-4"
          }, null, 8, ["alt"]),
          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("cargoV2.components.scanTableList.empty")), 1)
        ]))
  ]))
}